module.exports = __webpack_public_path__ + "img/contact.c808d5ff.svg";